import { NeutralAttackAttribute } from '@collector/sportsapi-client-legacy'

export const zones = new Map<number, NeutralAttackAttribute>([
  [1, NeutralAttackAttribute.Zone1],
  [2, NeutralAttackAttribute.Zone2],
  [3, NeutralAttackAttribute.Zone3],
  [4, NeutralAttackAttribute.Zone4],
  [5, NeutralAttackAttribute.Zone5],
  [6, NeutralAttackAttribute.Zone6],
])
